import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

// Reusable click-to-play video (poster frame + branded play button, plays with sound).
export const VideoHero = ({ src, label, title, note = "Tap to watch — sound on", className = "" }) => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const play = () => {
    const v = videoRef.current;
    if (!v) return;
    v.controls = true;
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
    setPlaying(true);
  };

  return (
    <section className={`relative bg-black border-y border-white/5 ${className}`} data-testid="video-block">
      <div className="relative w-full aspect-video max-h-[88vh] mx-auto overflow-hidden">
        <video
          ref={videoRef}
          src={`${src}#t=0.5`}
          preload="metadata"
          playsInline
          className="w-full h-full object-contain bg-black"
          data-testid="video-el"
          onEnded={() => setPlaying(false)}
        />
        {!playing && (
          <motion.button
            type="button"
            onClick={play}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="absolute inset-0 flex flex-col items-center justify-center gap-5 bg-gradient-to-t from-black/75 via-black/25 to-black/45 group cursor-pointer"
            data-testid="video-play"
            aria-label={title ? `Play ${title}` : "Play video"}
          >
            {label && (
              <span className="font-mono-plex text-[11px] tracking-[0.35em] uppercase text-orange-500">
                {label}
              </span>
            )}
            <span className="flex items-center justify-center w-20 h-20 rounded-full bg-orange-500 text-[#04070A] shadow-2xl transition-all duration-300 group-hover:scale-110 group-hover:bg-orange-400">
              <Play className="w-8 h-8 ml-1 fill-current" />
            </span>
            {title && (
              <span className="font-display text-3xl sm:text-5xl uppercase tracking-tight text-white text-center px-6 leading-none">
                {title}
              </span>
            )}
            {note && (
              <span className="font-mono-plex text-[10px] tracking-[0.25em] uppercase text-slate-300">
                {note}
              </span>
            )}
          </motion.button>
        )}
      </div>
    </section>
  );
};
